import { computed, ComputedRef, inject, provide, Ref } from "vue";
import * as language from "../lib/language";
import { addOfferUrl } from "../lib/addClickUrl";
import { BetData, CampaignOffer } from "../types/betData";
import { Offer } from "../types";

export function createOffer(betData: Ref<BetData>) {
  const languageCode = language.getLanugeCodeFromUrl();

  const defaultOffer: ComputedRef<CampaignOffer> = computed(
    () =>
      betData.value &&
      language.getValue(betData.value.operator.name, languageCode, "offer")
  );

  const campaignOffer = computed(() => {
    const offer = betData.value?.offer?.filter(
      offer =>
        // If no macros applied then use offer on all ad tags.
        // else only use offer if a macro matches the languagecode.
        !offer.macros ||
        offer.macros.length === 0 ||
        offer.macros.find(
          macro =>
            macro.key === "lang" &&
            language.normaliseEspnLanguageCode(macro.value) === languageCode
        )
    );
    if (!offer || offer.length === 0) return undefined;

    const randomSelection = Math.floor(Math.random() * offer.length);
    return addOfferUrl(offer[randomSelection]) as CampaignOffer;
  });

  const showOffer = computed(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const forceOffer = urlParams.get("forceOffer");
    const chanceOfOffer = Math.random();
    let showOffer = false;

    if (campaignOffer.value || chanceOfOffer < 0.2) {
      showOffer = true;
    }

    if (forceOffer && forceOffer === "true") {
      showOffer = true;
    }

    if (forceOffer && forceOffer === "false") {
      showOffer = false;
    }

    return showOffer;
  });

  const offer: ComputedRef<CampaignOffer> = computed(
    () => campaignOffer.value || defaultOffer.value
  );

  return {
    showOffer,
    offer
  };
}

type OfferComposition = ReturnType<typeof createOffer>;
export const OfferSymbol = Symbol("OfferSymbol");

export function provideOffer(BetData: Ref<BetData>) {
  provide(OfferSymbol, createOffer(BetData));
}

export function injectOffer() {
  return inject<OfferComposition>(OfferSymbol);
}
